/**
 * Figma-Aligned Mock Data
 *
 * This file contains mock data that matches the Figma design screenshots.
 * Used for development/demo purposes with environment toggle.
 */

import { ParsedAuction } from '../contexts/AuctionContext';

// ============================================================================
// HOMEPAGE HERO SECTION - "Bunda Hardcore" from The Dudes
// ============================================================================

export const mockHeroAuction: ParsedAuction = {
  auctionId: 1,
  title: "Bunda Hardcore",
  description: `
    <ul>
      <li>Vícebarevná oboustranná bunda PUFF s grafikou Hardcore.</li>
      <li>4 kapsy</li>
      <li>zapínání na zip a nýlonové šňůrky</li>
      <li>polyesterová výplň</li>
      <li>100% nylonový plášť</li>
    </ul>
  `,
  price: 2777,
  estimatedRetailPrice: 3490,
  photoUrls: [
    "https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=800&h=600&fit=crop"
  ],
  providerDescription: "The Dudes",
  startDate: new Date().toISOString(),
  status: "active"
};

// ============================================================================
// WINNERS PAGE - 12 Products Grid (4 rows x 3 columns)
// ============================================================================

export const mockWinnersData = [
  // Row 1
  {
    productName: "Apple iPhone 16 Pro 128 GB",
    productLabel: "Mobilní telefon",
    imageUrl: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=800&h=600&fit=crop",
    soldPrice: "18 660,- Kč",
    savings: "-28% z běžné ceny",
    avatarUrl: "https://i.pravatar.cc/150?img=11"
  },
  {
    productName: "Karla 7 dní, all inclusive",
    productLabel: "Dovolená",
    imageUrl: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800&h=600&fit=crop",
    soldPrice: "11 500,- Kč",
    savings: "-39% z běžné ceny",
    avatarUrl: "https://i.pravatar.cc/150?img=12"
  },
  {
    productName: "DJI Mini 3 Fly More Combo",
    productLabel: "Dron",
    imageUrl: "https://images.unsplash.com/photo-1473968512647-3e447244af8f?w=800&h=600&fit=crop",
    soldPrice: "14 500,- Kč",
    savings: "-19% z běžné ceny",
    avatarUrl: "https://i.pravatar.cc/150?img=13"
  },

  // Row 2
  {
    productName: "Moët & Chandon Imperial Brut",
    productLabel: "Nápoje",
    imageUrl: "https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?w=800&h=600&fit=crop",
    soldPrice: "1 250,- Kč",
    savings: "-23% z běžné ceny",
    avatarUrl: "https://i.pravatar.cc/150?img=14"
  },
  {
    productName: "Samsung Galaxy Tab S9",
    productLabel: "Elektronika",
    imageUrl: "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=800&h=600&fit=crop",
    soldPrice: "9 990,- Kč",
    savings: "-32% z běžné ceny",
    avatarUrl: "https://i.pravatar.cc/150?img=15"
  },
  {
    productName: "De'Longhi Magnifica S",
    productLabel: "Domácí spotřebiče",
    imageUrl: "https://images.unsplash.com/photo-1517668808822-9ebb02f2a0e6?w=800&h=600&fit=crop",
    soldPrice: "6 490,- Kč",
    savings: "-27% z běžné ceny",
    avatarUrl: "https://i.pravatar.cc/150?img=16"
  },

  // Row 3
  {
    productName: "Nike Air Max 90 Premium",
    productLabel: "Móda a doplňky",
    imageUrl: "https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=800&h=600&fit=crop",
    soldPrice: "2 390,- Kč",
    savings: "-35% z běžné ceny",
    avatarUrl: "https://i.pravatar.cc/150?img=17"
  },
  {
    productName: "Sony WH-1000XM5",
    productLabel: "Elektronika",
    imageUrl: "https://images.unsplash.com/photo-1587829741301-dc798b83add3?w=800&h=600&fit=crop",
    soldPrice: "5 790,- Kč",
    savings: "-22% z běžné ceny",
    avatarUrl: "https://i.pravatar.cc/150?img=18"
  },
  {
    productName: "Bosch Professional sada nářadí",
    productLabel: "Nářadí",
    imageUrl: "https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=800&h=600&fit=crop",
    soldPrice: "3 450,- Kč",
    savings: "-18% z běžné ceny",
    avatarUrl: "https://i.pravatar.cc/150?img=19"
  },

  // Row 4
  {
    productName: "Moderní stolní lampa",
    productLabel: "Dekorace",
    imageUrl: "https://images.unsplash.com/photo-1513694203232-719a280e022f?w=800&h=600&fit=crop",
    soldPrice: "1 890,- Kč",
    savings: "-25% z běžné ceny",
    avatarUrl: "https://i.pravatar.cc/150?img=20"
  },
  {
    productName: "Herman Miller Aeron Chair",
    productLabel: "Kancelář",
    imageUrl: "https://images.unsplash.com/photo-1531346878377-a5be20888e57?w=800&h=600&fit=crop",
    soldPrice: "22 500,- Kč",
    savings: "-30% z běžné ceny",
    avatarUrl: "https://i.pravatar.cc/150?img=21"
  },
  {
    productName: "Tesla Model 3 víkendový pronájem",
    productLabel: "Auto",
    imageUrl: "https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=800&h=600&fit=crop",
    soldPrice: "4 990,- Kč",
    savings: "-20% z běžné ceny",
    avatarUrl: "https://i.pravatar.cc/150?img=22"
  }
];

// ============================================================================
// SIDEBAR PRODUCT - Consistent across Blog, About Us, Contact, Help
// ============================================================================

export const mockSidebarProduct: ParsedAuction = {
  auctionId: 999,
  title: "Plavba po Jadranu",
  description: "Zažijte luxusní plavbu po Jadranu s prvotřídním komfortem a stylem.",
  price: 100000,
  estimatedRetailPrice: 105263,
  photoUrls: [
    "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=800&h=600&fit=crop"
  ],
  providerDescription: "",
  startDate: new Date().toISOString(),
  status: "active",
};

export const mockActiveAuctions: ParsedAuction[] = [
  mockHeroAuction,
  {
    auctionId: 2,
    title: "Víkend v boutique hotelu",
    description: "Dvě noci pro dva se snídaní, wellness zónou a pozdním check-outem v centru Prahy.",
    price: 4890,
    estimatedRetailPrice: 8200,
    photoUrls: [
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1522798514-97ceb8c4f1c8?w=800&h=600&fit=crop",
    ],
    providerDescription: "Hotel Aurea",
    startDate: new Date(Date.now() + 3600000).toISOString(),
    status: "active",
  },
  {
    auctionId: 3,
    title: "DJI Mini 4 Pro Fly More",
    description: "Lehký dron se 4K kamerou, třemi bateriemi a ovladačem pro pohodlné cestování i natáčení.",
    price: 16990,
    estimatedRetailPrice: 23990,
    photoUrls: [
      "https://images.unsplash.com/photo-1473968512647-3e447244af8f?w=800&h=600&fit=crop",
    ],
    providerDescription: "Aero Tech",
    startDate: new Date(Date.now() + 7200000).toISOString(),
    status: "active",
  },
  {
    auctionId: 4,
    title: "Apple Watch Ultra 2",
    description: "Prémiové chytré hodinky s titanovým tělem, GPS a výdrží na několik dnů.",
    price: 13490,
    estimatedRetailPrice: 21990,
    photoUrls: [
      "https://images.unsplash.com/photo-1546868871-7041f2a55e12?w=800&h=600&fit=crop",
    ],
    providerDescription: "iStores Premium",
    startDate: new Date(Date.now() + 10800000).toISOString(),
    status: "active",
  },
  {
    auctionId: 5,
    title: "PlayStation 5 Pro",
    description: "Konzole nové generace s dvěma ovladači a ročním předplatným PlayStation Plus.",
    price: 11590,
    estimatedRetailPrice: 16990,
    photoUrls: [
      "https://images.unsplash.com/photo-1606144042614-b2417e99c4e3?w=800&h=600&fit=crop",
    ],
    providerDescription: "Next Level Gaming",
    startDate: new Date(Date.now() + 14400000).toISOString(),
    status: "active",
  },
  {
    auctionId: 6,
    title: "Wellness pobyt v Jeseníkách",
    description: "Třídenní pobyt pro dva s masáží, saunovým světem a večeří o třech chodech.",
    price: 6290,
    estimatedRetailPrice: 11900,
    photoUrls: [
      "https://images.unsplash.com/photo-1519046904884-53103b34b206?w=800&h=600&fit=crop",
    ],
    providerDescription: "Resort Horský klid",
    startDate: new Date(Date.now() + 18000000).toISOString(),
    status: "active",
  },
];

// ============================================================================
// HELPER: Convert winners data to ParsedAuction format
// ============================================================================

const parseCurrency = (value: string) => parseInt(value.replace(/[^\d]/g, ""), 10);

const parseSavingsPercent = (value: string) => {
  const match = value.match(/(\d+)/);
  return match ? parseInt(match[1], 10) : undefined;
};

export const convertToWinnersFormat = (mockData: typeof mockWinnersData) => {
  return mockData.map((item, index) => {
    const soldPrice = parseCurrency(item.soldPrice);
    const savingsPercent = parseSavingsPercent(item.savings);
    const estimatedRetailPrice = savingsPercent
      ? Math.round(soldPrice / (1 - savingsPercent / 100))
      : undefined;

    return {
      auctionId: 200 + index,
      title: item.productName,
      description: item.productLabel,
      price: soldPrice,
      estimatedRetailPrice,
      photoUrls: [item.imageUrl],
      providerDescription: "",
      startDate: new Date(Date.now() - (index * 86400000)).toISOString(),
      status: "completed" as const,
    };
  });
};

export const mockCompletedAuctions: ParsedAuction[] = convertToWinnersFormat(mockWinnersData);
